
<template>
  <div class="card" @click="onClick">
    <div class="header">
      <div class="checkbox" :class="{active:active==true}"></div>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  model: {
    prop: 'active',
    event: 'change'
  },
  props: {
    active: {
      type: Boolean,
      defalut: false
    }
  },
  methods: {
    onClick () {
      if (this.active === false) {
        this.$emit('change', this.active)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  background-color: white;
  border-radius: 10px;
}
.header {
  position: relative;
  height: 30px;
  display: flex;
}

.checkbox {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid red;
  position: absolute;
  transform: translate(-40px, 25px);
  right: -50px;
  top: -30px;
}
.active {
  background-color: red;
}
.content {
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 35px;
}
</style>
